import React from 'react';
import ColorSwatch from 'components/colorSwatch/color-swatch';
import { getActiveIcon } from 'library/helpers';
import { DocLink, DocPages } from 'components/Help/';
import LeaveTypeFormInput from './input';

const config = {
  init: {
    color: '#000',
    active: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Colour',
        dataIndex: 'color',
        sorter: false,
        width: '110px',
        align: 'center',
        render: (text, record) => (<ColorSwatch value={record.color} />)
      },
      {
        title: 'Managed in 1SAP',
        dataIndex: 'is_integration_managed',
        width: '200px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Active',
            value: true
          },
          {
            text: 'Inactive',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.is_integration_managed)
      },
      {
        title: 'SAP Code',
        dataIndex: 'sap_code',
        width: '200px',
        align: 'center',
        sorter: true
      },
      {
        title: 'Active',
        dataIndex: 'active',
        width: '120px',
        align: 'center',
        sorter: true,
        filterMultiple: false,
        filters: [
          {
            text: 'Active',
            value: true
          },
          {
            text: 'Inactive',
            value: false
          }
        ],
        render: (text, record) => getActiveIcon(record.active)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the leave type
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.leaveType}>Leave Types</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Leave Type',
    title: 'Leave Type',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <LeaveTypeFormInput
            {...props}
            messages={{
              is_integration_managed: 'This data is managed by another system and cannot be edited'
            }}
            title="Leave Type"
          />
        )
      }
    ]
  }
};

export default config;
